module.exports = __webpack_public_path__ + "img/1440.55a88a01.jpg";